module.exports = __webpack_public_path__ + "img/hm.e49ba24a.svg";